import loadable from '@loadable/component';

export const OrgDashboardRepostInternshipPageLoadable = loadable(
  () => import('./OrgDashboardRepostInternshipPage'),
  { resolveComponent: (module) => module.OrgDashboardRepostInternshipPage },
);
